<template>
	<div class="w1200 flex myinfo">
		<choice-menu></choice-menu>
		<div class="flex flex-direction align-stretch benben-flex-layout myinfo_1">
			<div class="myinfo_2">ID:{{userInfo.number}}</div>
			<div class="flex benben-flex-layout flex-wrap align-center">
				<div class="myinfo_3 pointer" v-if=" company.status=='-1' || company.status=='2'" @click="caozuo(1)">{{$t('绑定企业')}}</div>
				<div class="myinfo_3_1 pointer" v-if=" company.name">{{company.name}}</div>
				<div class="myinfo_3_2" v-if=" company.status=='2'">{{$t('审核拒绝')}}</div>
				<div class="myinfo_3_2" v-if=" company.status==0">{{$t('审核中')}}</div>
			</div>
			<div class="myinfo_8" v-if=" company.status=='2'">
				拒绝原因：123
			</div>
			<div class="myinfo_4 flex benben-flex-layout flex-wrap align-center">
				<div class="myinfo_4_1">
					<div class="myinfo_4_2">Balance</div>
					<div class="flex ">
						<div class="myinfo_4_3">{{moneyDetails.meal_ticket}}</div>
						<div class="myinfo_4_4">{{$t('饭票')}}</div>
					</div>
				</div>
				<div class="myinfo_4_5 flex">
					<div class="myinfo_4_6 pointer" @click="caozuo(2)">{{$t('详情')}}</div>
					<div class="myinfo_4_7 pointer" @click="caozuo(3)">{{$t('充值')}}</div>
				</div>
			</div>
			<div class="myinfo_5">{{$t('我的预约')}}</div>
			<div v-loading="loading"  :element-loading-text="$t('拼命加载中')">
				<div v-if="ming_list.length > 0" >
				    <template v-for="(item,index) in ming_list">
						<div class="myinfo_6 flex flex-direction align-stretch benben-flex-layout pointer" @click="caozuo(5,item)">
							<div class="myinfo_6_1">{{item.address_ifno.address}}{{item.address_ifno.detail}}</div>
							<template v-for='(child,key1) in item.chlid'>
								<div class="flex myinfo_6_6">
									<img class="myinfo_6_2" :src='child.thumb' alt="" srcset="">
								    <div class="myinfo_6_3 flex flex-sub flex-direction align-stretch benben-flex-layout">
										<div class="myinfo_6_4">{{child.name}}</div>
										<div class="myinfo_6_5">{{child.num}}{{$t('份')}}</div>
									</div>
								</div>
							</template>
							
						</div>
					</template>
				</div>
				<div class="myinfo_7 flex flex-direction flex-wrap align-center benben-flex-layout" v-else>
					<img class="myinfo_7_1" src="https://api.ezlunch.club/pc/image/29.png" alt="" srcset="">
					<div class="myinfo_7_2">{{$t('您目前没有即将送餐的订单')}}~</div>
					<div class="myinfo_7_3 pointer" @click="caozuo(4)">{{$t('前往预定')}}</div>
				</div>
				<div v-if="ming_list.length > 0" style="text-align: center;margin: 20px  0;">
					<el-pagination
					   @current-change="handleCurrentChange"
					   layout="prev, pager, next"
					   :current-page.sync="page" :page-size="page_size"
					   :total="total">
					 </el-pagination>
				</div>
			</div>
			
			 
			
		</div>
	</div>
</template>

<script>
	import ChoiceMenu from "../components/choiceMenu.vue"
	export default {
		components: {
			ChoiceMenu
		},
		data() {
			return {
				total:0,
				page:1,
				page_size:10,
				loading:true,
				company:'',
				ming_list:'',
				moneyDetails:'',
				userInfo:'',
				
			}
		},
		created() {
			if(window.sessionStorage.getItem('token')){
				this.post68db493363a59()
				this.post68d0b9d0dacb2()
				this.post68d3bf9d40c03()
				this.post5c78c4772da97()
			}else{
				this.$router.push({
					name: 'login',
				});
			}
			
		},

		methods: {
			gengxin(){
				this.loading = true
				this.post68db493363a59()
				this.post68d0b9d0dacb2()
				this.post68d3bf9d40c03()
				this.post5c78c4772da97()
			},
			
			
			//个人中心-获取会员详细信息
			post5c78c4772da97(){
				this.$api.post(this.$apiUrls.post5c78c4772da97).then((res) => {
					if(res.code == 1){
						this.userInfo = res.data
					}else{
						this.$message.error(res.msg);
						return
					}
				})
			},
			// 获取会员饭票资产
			post68d3bf9d40c03(){
				this.$api.post(this.$apiUrls.post68d3bf9d40c03).then((res) => {
					if(res.code == 1){
						this.moneyDetails = res.data
					}else{
						this.$message.error(res.msg);
						return
					}
				})
			},
			//获取企业绑定信息
			post68d0b9d0dacb2(){
				this.$api.post(this.$apiUrls.post68d0b9d0dacb2).then((res) => {
					if(res.code == 1){
						this.company = res.data
					}else{
						this.$message.error(res.msg);
						return
					}
				})
			},
			// 切换页面
			handleCurrentChange(val){
				this.page = val
				this.post68db493363a59()
			},
			//查询我的预约-明天一天的订单
			post68db493363a59(){
				this.$api.post(this.$apiUrls.post68db493363a59,{page:this.page,list_rows:this.page_size,}).then((res) => {
					if(res.code == 1){
						this.ming_list = res.data.data
						this.total = res.data.total
						this.loading = false
					}else{
						this.$message.error(res.msg);
						return
					}
				})
			},
			caozuo(type,item){
				let url = ''
				if(type == 1){
					url = 'bind'
				}else if(type == 2){
					url = 'mealTicket'
				}else if(type == 3){
					url = 'topUp'
				}else if(type == 4){
					url = 'orderFood'
				}else if(type == 5){
					url = 'orderDetal'
					window.sessionStorage.setItem('order_type',1);
					window.sessionStorage.setItem('order_id', item.aid);
				}
				this.$router.push({
					name: url,
				});
			}
		}
	}
</script>

<style lang="scss" scoped>
	::v-deep {
		.el-loading-mask {
			opacity: 1 !important; 
			background-color: rgba(255, 255, 255, 1) !important;
		}
	}
	.myinfo{
		margin-top: 20px;
	}
	.myinfo_1{
		width: 980px;
		margin: 0 0 0 220px;
		padding:0 20px 100px;
		background: #fff;
		box-sizing: border-box;
	}
	.myinfo_2{
		padding: 20px 0;
		border-bottom: 1px solid #EEEEEE;
		font-weight: bold;
		font-size: 16px;
		color: #333333;
	}
	.myinfo_3{
		// min-width: 100px;
		height: 32px;
		background: rgba(255,255,255,0.08);
		border-radius: 6px 6px 6px 6px;
		border: 1px solid #FF770F;
		font-weight: 400;
		font-size: 14px;
		color: #FF770F;
		text-align: center;
		line-height: 32px;
		margin: 16px 16px 0 0;
		padding: 0 22px;
	}
	.myinfo_3_1{
		height: 32px;
		background: #F3F3F3;
		border-radius: 6px 6px 6px 6px;
		font-weight: 400;
		font-size: 14px;
		color: #333333;
		text-align: center;
		line-height: 32px;
		margin: 16px 0 0 0;
		padding: 0 22px;
	}
	.myinfo_3_2{
		
		font-weight: bold;
		font-size: 14px;
		color: #FF770F;
		line-height: 32px;
		margin: 16px 0 0 12px;
	}
	.myinfo_4{
		width: 590px;
		height: 97px;
		background: #FFF7F1;
		border-radius: 4px 4px 4px 4px;
		margin: 16px 0 0 0;
		padding: 0 24px;
	}
	.myinfo_4_2{
		font-weight: 400;
		font-size: 14px;
		color: #666666;
		margin:0 0 12px 0;
	}
	.myinfo_4_3{
		font-weight: 500;
		font-size: 18px;
		color: #333333;
	}
	.myinfo_4_4{
		font-weight: 500;
		font-size: 12px;
		color: #333333;
		margin: 4px 0 0 6px;
	}
	.myinfo_4_5{
		margin: 0 0 0 auto;
	}
	.myinfo_4_6{
		// width: 72px;
		height: 36px;
		padding: 0 22px;
		border-radius: 4px 4px 4px 4px;
		border: 1px solid #FF8A24;
		text-align: center;
		line-height: 36px;
		font-weight: 400;
		font-size: 14px;
		color: #FF8A24;
	}
	.myinfo_4_7{
		height: 36px;
		padding: 0 22px;
		border-radius: 4px 4px 4px 4px;
		border: 1px solid #FF8A24;
		text-align: center;
		line-height: 36px;
		background: #FF770F;
		font-weight: 400;
		font-size: 14px;
		color: #FFFFFF;
		margin: 0 0 0 16px;
	}
	.myinfo_5{
		font-weight: 400;
		font-size: 16px;
		color: #333333;
		margin: 24px 0 0 0;
	}
	.myinfo_6{
		background: #F8F8FA;
		border-radius: 8px 8px 8px 8px;
		padding: 16px;
		margin: 16px 0 0 0;
	}
	.myinfo_6_1{
		font-weight: 400;
		font-size: 14px;
		color: #333333;
	}
	.myinfo_6_2{
		width: 96px;
		height: 96px;
		margin: 0 12px 0 0;
	}
	.myinfo_6_3{
		height: 96px;
	}
	.myinfo_6_4{
		font-weight: bold;
		font-size: 14px;
		color: #333333;
	}
	.myinfo_6_5{
		font-weight: 400;
		font-size: 12px;
		color: #666666;
		margin: auto 0 0 0;
	}
	.myinfo_6_6{
		margin: 16px 0 0 0;
	}
	.myinfo_7{
		padding: 72px 0;
	}
	.myinfo_7_1{
		width: 217px;
		height: 177px;
	}
	.myinfo_7_2{
		font-weight: 400;
		font-size: 14px;
		color: #999999;
	}
	.myinfo_7_3{
		height: 42px;
		background: #FF8A24;
		border-radius: 6px 6px 6px 6px;
		padding: 0 38px;
		font-weight: 400;
		font-size: 16px;
		color: #FFFFFF;
		line-height: 42px;
		margin: 39px 0 0 0;
	}
	.myinfo_8{
		color: red;
		margin: 12px 0 0 0;
	}
</style>